module.exports = __webpack_public_path__ + "media/empty-states/kiosk-mode-e0e3ba83.png";